import { h, Component } from 'preact';
import { route } from 'preact-router';
import { Link } from 'preact-router/match';
import style from './style.css';
import { getApiPath } from "../../../path";

class AdminMenu extends Component {

  state = {
    locale:"",
    selectedDb: window.location.pathname.split("/")[3],
    dbAccess:[],
    menuItems: [{
      label: "Home",
      href: "/admin/"
    },
    {
      label: "Users",
      href: "/admin/users"
    }],
    role: sessionStorage.getItem("vumc-profile") == null ? "": JSON.parse(sessionStorage.getItem("vumc-profile"))["id_roles"]
  };

  constructor(props) {
    super(props);
    if(sessionStorage.getItem("vumc-profile") == null){
      route("/"+ props.locale + "/admin/login");
    }
    let fetchPath = getApiPath(props.locale, `menu/admin`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        if (result.status === 200) {
          this.setState(previousState => ({
            ...previousState,
            menuItems: this.state.menuItems,
            dbAccess: result.data.map(db=> parseInt(db.id))
          }));
        }
        if (result.status === 401) {
          route("/"+ props.locale + "/admin/login");
        }
      });
  }

  goto(url) {

    this.setState(previousState => ({
      ...previousState,
      selectedDb: url
    }));

    route("/" + this.props.locale + "/admin/" + url + "/literature");
  }

  render() {
    if (this.state.menuItems.length > 0) {
      let menu = this.state.menuItems.map(item => {
        if (!(item.label == "Users" && this.state.role == 2)) {
          return (<Link activeClassName={style.active} href={`/${this.props.locale}${item.href}`}>{item.label}</Link>);
        }
      });

      return (
        <header class={style.header}>
          <nav class={style['nav--main']}>
            {menu}
          </nav>
          <select onInput={(e) => { this.goto(e.target.value) }}>
            {this.state.dbAccess.indexOf(24) != -1 && <option value="roman" selected={this.state.selectedDb == "roman"}> { this.props.locale == 'nl' ? 'Romans en verhalen' : 'Novels and stories'}</option>}
            {this.state.dbAccess.indexOf(26) != -1 && <option value="pathography" selected={this.state.selectedDb == "pathography"}>{ this.props.locale == 'nl' ? 'Ziektebiografieën':'Pathographies'}</option>}
            {this.state.dbAccess.indexOf(27) != -1 && <option value="film" selected={this.state.selectedDb == "film"}>{ this.props.locale == 'nl' ? 'Films en documentaires':'Film, documentary and television'}</option>}
            {this.state.dbAccess.indexOf(25) != -1 && <option value="art" selected={this.state.selectedDb == "art"}>{ this.props.locale == 'nl' ? 'Beelden van geneeskunde':'Images of medicine'}</option>}
            {this.state.dbAccess.indexOf(28) != -1 && <option value="about" selected={this.state.selectedDb == "about"}>{ this.props.locale == 'nl' ? 'Over literatuur en geneeskunde':'About literature and medicine'}</option>}
            {this.state.dbAccess.indexOf(29) != -1 && <option value="poetry" selected={this.state.selectedDb == "poetry"}>{ this.props.locale == 'nl' ? 'Poëzie':'Poetry'}</option>}
          </select>
        </header>);
    }
  }
}

export default AdminMenu;